<template>
  <PostBody
    :id="post.id"
    :title="post.title"
    :body="post.body"
    :date="post.date"
  />
  <Comment
    v-for="comment in post.comments"
    :key="comment.title"
    :comment="comment"
  />
  <CommentForm :postNameUrl="post.name" @comment-added="commentAdded" />
</template>
<script>
import PostBody from "../components/PostBody.vue";
import Comment from "../components/Comment.vue";
import CommentForm from "../components/CommentForm.vue";
import { postByTitle, listComments } from "../firestoreHelper.js";

export default {
  components: { PostBody, Comment, CommentForm },
  data() {
    return {
      post: {
        id: "",
        title: "",
        body: "",
        name: "",
        date: "",
        comments: [],
      },
    };
  },
  created() {
    const noDashesTitle = this.$route.params.title.replaceAll("-", " ");

    postByTitle(noDashesTitle).then((data) => {
      this.post = data;

      listComments(this.post.name).then((data) => {
        this.post.comments = data;
      });
    });
  },
  methods: {
    commentAdded(comment) {
      this.post.comments.push(comment);
    },
  },
};
</script>
<style scoped>
</style>


